import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './layout.css';
import Home from './Home';
import ContactUs from './contact-us';
import AboutUs from './about-us';
import Events from './events';
import WhyChoose from './why-choose';
import { ALL_IMAGES } from './config/imagePaths';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function PreloadImages() {
  useEffect(() => {
    ALL_IMAGES.forEach((src) => {
      const image = new Image();
      image.src = src;
    });
  }, []);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <PreloadImages />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/why-choose" element={<WhyChoose />} />
        <Route path="/events" element={<Events />} />
        <Route path="/contact" element={<ContactUs />} />
      </Routes>
    </Router>
  );
}

export default App;
